module.exports = __webpack_public_path__ + "img/sergipe.68ed892e.jpg";